import type React from 'react';
import Styles from './statuses.module.scss';

export const PartiallyFinished: React.FC = () => (
  <div>
    <h3 className={Styles.Title}>完了しました</h3>
    <p className={Styles.Description}>工事を依頼せずに案件を完了しました</p>
  </div>
);
